module.exports = " <div :class=containerClassObject _v-0a95ad80=\"\"> <div class=post-webwidget-v2-now-playing-section-layout-image-container _v-0a95ad80=\"\"> <slot name=now-playing-image _v-0a95ad80=\"\"></slot> </div> <div class=post-webwidget-v2-now-playing-section-layout-detail-container _v-0a95ad80=\"\"> <slot name=now-playing-detail _v-0a95ad80=\"\"></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0a95ad80!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/v2-components/NowPlayingSectionLayout.vue
// module id = 313
// module chunks = 0